import styled from 'styled-components';
import Text from '../Typography/Text';
import { Margin } from '../Spacing';
export const IconTextContainer = styled(Margin)`
  display: flex;
  align-items: ${({
  $alignItems
}) => $alignItems};
  justify-content: ${({
  $justify
}) => $justify};
  gap: ${({
  $gap,
  theme
}) => theme.spacing[$gap]};
`;
export const StyledText = styled(Text)`
  order: ${({
  $textFirst
}) => $textFirst ? -1 : 0};
`;
//# sourceMappingURL=styles.js.map